import {
  BankAccountOperationSource,
  BankAccountOperationStatus,
  CurrencySaleRevaluationType,
  PaymentActivity,
  BankReconciliationActionType,
} from 'further-types/lp/bank-reconciliation';

export const BankAccountOperationStatusLabels = {
  [BankAccountOperationStatus.Unreconciled]: 'Unreconciled',
  [BankAccountOperationStatus.Reconciled]: 'Reconciled',
};

export const BankAccountOperationSourceLabels = {
  [BankAccountOperationSource.BankFeed]: 'Bank feed',
  [BankAccountOperationSource.Manual]: 'Upload',
};

export const CurrencySaleRevaluationTypeLabels = {
  [CurrencySaleRevaluationType.CurrencySaleGain]:
    'Reconciliation (Currency Sale Gain)',
  [CurrencySaleRevaluationType.CurrencySaleLoss]:
    'Reconciliation (Currency Sale Loss)',
};

export const BankReconciliationActionTypeLabels = {
  [BankReconciliationActionType.ReconciliationCreated]: 'Reconciliation',
};

export const PaymentActivityLabels = {
  [PaymentActivity.Created]: 'Created',
  [PaymentActivity.PaymentReceived]: 'Payment received',
  [PaymentActivity.PrepaymentReceived]: 'Prepayment received',
  [PaymentActivity.PrepaymentResolved]: 'Prepayment resolved',
};
